// ** Initial State
const initialState = {
  GradationList: [],
  loading_Gradation: false,
  error_Gradation: '',
  
  PaymentCountList: [],
  loading_Payment: false,
  error_Payment: '',

  PaymentValueList: [],
  loading_PaymentValue: false,
  error_PaymentValue: '',

  PurchaseOrderList: [],
  loading_PurchaseOrder: false,
  error_PurchaseOrder: ''
}

const dashbaordReducer = (state = initialState, action) => {
  switch (action.type) {
    // Gradation
       case 'Gradation_LOADING': {
           return {
               ...state,
               loading_Gradation: true,
               error_Gradation:''
           }
       }
       case 'Gradation_SUCCESS': {
           return {
               ...state,
               GradationList: action.data,
               loading_Gradation: false
           }
       }
       case 'Gradation_ERROR': {
           return {
               ...state,
               loading_Gradation: false,
               error_Gradation: action.error
           }
       }

     // Payment
       case 'Payment_LOADING': {
           return {
               ...state,
               loading_Payment: true,
               error_Payment:''
           }
       }
       case 'Payment_SUCCESS': {
           return {
               ...state,
               PaymentCountList: action.data,
               loading_Payment: false
           }
       }
       case 'Payment_ERROR': {
           return {
               ...state,
               loading_Payment: false,
               error_Payment: action.error
           }
       }

       // Payment Value
       case 'PaymentValue_LOADING': {
           return {
               ...state,
               loading_PaymentValue: true,
               error_PaymentValue:''
           }
       }
       case 'PaymentValue_SUCCESS': {
           return {
               ...state,
               PaymentValueList: action.data,
               loading_PaymentValue: false
           }
       }
       case 'PaymentValue_ERROR': {
           return {
               ...state,
               loading_PaymentValue: false,
               error_PaymentValue: action.error
           }
       }

        // Purchase Order
       case 'PODashboard_LOADING': {
           return {
               ...state,
               loading_PurchaseOrder: true,
               error_PurchaseOrder:''
           }
       }
       case 'PODashboard_SUCCESS': {
           return {
               ...state,
               PurchaseOrderList: action.data,
               loading_PurchaseOrder: false
           }
       }
       case 'PODashboard_ERROR': {
           return {
               ...state,
               loading_PurchaseOrder: false,
               error_PurchaseOrder: action.error
           }
       }

    default:
      return state
  }
}

export default dashbaordReducer
